import { Checkbox } from "@amzn/stencil-react-components/checkbox";
import { Row } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import { useController, useFormContext } from "react-hook-form";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { CheckoutFormState } from "@/pages/Checkout/checkout-form.types";
import { REQUIRED_FIELD_ERROR } from "@/pages/Checkout/checkout-form.util";
import React from "react";

const STRING_PATH = "checkout.formPanel";
const HARDWARE_OWNERSHIP_POLICY_LINK = "https://policy.a2z.com/docs/37992/publication";
const IT_SERVICES_HARDWARE_POLICY_LINK = "https://policy.a2z.com/docs/44534/publication";

export const PolicyConfirmation: React.FC = () => {
  const { control } = useFormContext<CheckoutFormState>();
  const { field, fieldState } = useController<CheckoutFormState, "policyConfirmationCheckbox">({
    control,
    name: "policyConfirmationCheckbox",
    rules: { required: REQUIRED_FIELD_ERROR },
  });

  return (
    <Row gridGap="S200">
      <Checkbox
        data-testid="policy-checkbox"
        checked={field.value}
        error={fieldState.invalid}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          field.onChange(event.target.checked)
        }
      />
      <Text fontSize="T200" color="neutral90">
        {getString(`${STRING_PATH}.iHaveRead`)}
        <Link href={HARDWARE_OWNERSHIP_POLICY_LINK} target="_blank">
          {getString(`${STRING_PATH}.hardwareOwnershipPolicy`)}
        </Link>
        {getString(`${STRING_PATH}.and`)}
        <Link href={IT_SERVICES_HARDWARE_POLICY_LINK} target="_blank">
          {getString(`${STRING_PATH}.itServicesHardwarePolicy`)}
        </Link>
        . *
      </Text>
    </Row>
  );
};
